import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthenticatedFetch } from "@/lib/authenticatedFetch";

// Deny-by-default backend: raw `fetch` callers must carry the session too.
installAuthenticatedFetch();

// ─────────────────────────────────────────────────────────────────────────────
// Cosmetic-only console filter (DEV ONLY).
// React's dev DOM validator emits a transient `<circle r="undefined">` warning
// for animated Recharts/Framer-motion SVG shapes when the first paint runs
// before the layout effect supplies the radius. The DOM never actually contains
// an invalid circle (audited via `document.querySelectorAll('circle')`), so
// this is a known false-positive that does not appear in production builds.
// We silence ONLY this exact message to keep the console actionable.
// ─────────────────────────────────────────────────────────────────────────────
if (process.env.NODE_ENV !== 'production') {
  const _origError = console.error;
  console.error = (...args) => {
    const first = args[0];
    if (typeof first === 'string' && first.includes('<circle> attribute r: Expected length')) {
      return; // suppress
    }
    return _origError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
